import React, { useState, useEffect } from "react";
import "./formCompetence.css";
import { Form, Input, Button, Typography, Space, Row, Col, Select } from "antd";

const { Text, Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const FormCompetence = (props) => {
    const [isEditing, setIsEditing] = useState(false);

    // Funciones de edición y guardado
    const handleEditClick = () => setIsEditing(true);
    const handleSaveClick = () => {
        setIsEditing(false);
        props.saveCompetence();
    };

    const handleCreateClick = () => {
        props.saveCompetence();
    };

    useEffect(() => {
        setIsEditing(false);
    }, [props.cmpId]);

    const handleDescriptorChange = (categoryId, index, value) => {
        // ✅ Clonar el array de descriptores sin modificar el original
        const updatedDescriptors = [...props.cmpDescriptors];

        // ✅ Encontrar la categoría específica
        const categoryIndex = updatedDescriptors.findIndex(category => category.category_id === categoryId);
        if (categoryIndex !== -1) {
            // ✅ Crear una nueva copia de los descriptores dentro de la categoría
            const updatedCategory = { ...updatedDescriptors[categoryIndex] };
            updatedCategory.descriptors = [...updatedCategory.descriptors];

            // ✅ Modificar solo el descriptor específico
            updatedCategory.descriptors[index] = value;

            // ✅ Reemplazar la categoría modificada en el array principal
            updatedDescriptors[categoryIndex] = updatedCategory;

            // ✅ Actualizar el estado con el nuevo array
            props.setCmpDescriptors(updatedDescriptors);
        }
    };

    const handleJobTitlesChange = (categoryId, selectedValues) => {

        const updatedCategories = props.cmpDescriptors.map(category => {
            if (category.category_id === categoryId) {
                // Obtener los títulos de trabajo actuales
                const existingJobTitles = category.job_titles || [];

                // Obtener los títulos seleccionados (IDs)
                const selectedJobTitles = selectedValues.map(id => {
                    // Buscar si el título ya existe en la categoría
                    const existingJob = existingJobTitles.find(job => job.jtt_id === id);
                    return existingJob ? existingJob : { jtt_id: id, jtt_title: `Título ${id}` };
                });

                return {
                    ...category,
                    job_titles: selectedJobTitles // Asignar los títulos actualizados
                };
            }
            return category;
        });

        props.setCmpDescriptors(updatedCategories);
    };

    return (
        <Form layout="horizontal">
            {/* Nombre de la competencia */}
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Nombre:</Text></Col>
                <Col span={20}>
                    {isEditing || props.newCompetence ? (
                        <Input 
                            value={props.cmpCompetence} 
                            onChange={(e) => props.setCmpCompetence(e.target.value.toUpperCase())} 
                        />
                    ) : (
                        <Text>{props.cmpCompetence || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Descripción de la competencia */}
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Descripción:</Text></Col>
                <Col span={20}>
                    {isEditing || props.newCompetence ? (
                        <Input 
                            value={props.cmpDescription} 
                            onChange={(e) => props.setCmpDescription(e.target.value.toUpperCase())} 
                        />
                    ) : (
                        <Text>{props.cmpDescription || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Descriptores agrupados por categoría */}
            {props.cmpDescriptors?.map((category) => (
                <div key={category.category_id} style={{ marginTop: 20 }}>
                    {/* Nombre de la Categoría con estilo */}
                    <Title level={4} style={{ color: "#00b7a3", fontSize: "16px" }}>
                        {category.category_name}
                    </Title>

                    {category.descriptors.map((descriptor, index) => (
                        <Row key={index} align="middle" style={{ marginBottom: 10 }}>
                            <Col span={4}><Text>Descriptor {index + 1}:</Text></Col>
                            <Col span={20}>
                                {isEditing || props.newCompetence ? (
                                    <TextArea
                                        autoSize={{ minRows: 2, maxRows: 4 }}
                                        value={descriptor}
                                        onChange={(e) => handleDescriptorChange(category.category_id, index, e.target.value)}
                                    />
                                ) : (
                                    <Text>{descriptor || "No especificado"}</Text>
                                )}
                            </Col>
                        </Row>
                    ))}

                    {/* Job Titles */}
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={4}><Text>Cargos:</Text></Col>
                        <Col span={20}>
                            {isEditing || props.newCompetence ? (
                                <Select
                                    mode="multiple"
                                    style={{ width: "100%" }}
                                    placeholder="Seleccione los cargos asociados a esta categoría"
                                    value={category.job_titles?.map(job => job.jtt_id)}
                                    onChange={(selectedValues) => handleJobTitlesChange(category.category_id, selectedValues)}
                                >
                                    {props.dataJobTitles?.map(job => (
                                        <Option key={job.jtt_id} value={job.jtt_id}>
                                            {job.jtt_title}
                                        </Option>
                                    ))}
                                </Select>
                            ) : (
                                <ul style={{ paddingLeft: 20 }}>
                                    {category.job_titles?.map(job => (
                                        <li key={job.jtt_id}>{job.jtt_title}</li>
                                    ))}
                                </ul>
                            )}
                        </Col>
                    </Row>
                </div>
            ))}

            {/* Botones */}
            <Row justify="end" style={{ marginTop: 20 }}>
                <Space>
                    {props.newCompetence ? (
                        <Button type="primary" onClick={handleCreateClick}>Guardar</Button>
                    ) : isEditing ? (
                        <>
                            <Button type="primary" onClick={handleSaveClick}>Guardar</Button>
                            <Button onClick={() => setIsEditing(false)}>Cancelar</Button>
                        </>
                    ) : (
                        <Button type="default" onClick={handleEditClick}>Editar</Button>
                    )}
                </Space>
            </Row>
        </Form>
    );
};

export default FormCompetence;
